import React, { useEffect } from 'react';
import Selector from 'components/inputs/Selector';
import { isOperationNull } from 'helpers/filterHelper';
import SimpleValuePicker from './SelectorManagees/SimpleValuePicker';
import { getOperationOptions } from './hooks';
import { TextFieldProps } from '@mui/material';

const getValueSelector = (
    operation: FilterOperationsT | DynamicFilterOperationsT,
) => {
    if (isOperationNull(operation)) return () => <></>;
    return SimpleValuePicker;
};

type Props = {
    filter: SentenceFilterT;
    setFilter: FlowAnyFunction;
    isPerimeterFilter: boolean | null | undefined;
    isDisabled: boolean | null | undefined;
    shouldDebounce?: boolean;
    inputProps?: TextFieldProps;
};

const SelectorManager = ({
    filter,
    setFilter,
    isPerimeterFilter,
    isDisabled,
    shouldDebounce,
    inputProps,
}: Props): React.ReactElement => {
    const operationOptions = getOperationOptions(filter.type);

    const ValueSelector = getValueSelector(filter.operation);

    useEffect(() => {
        // We reset the operation when the available operations does not contains the
        // currently selected operation (this can happen when the field changes)
        if (
            operationOptions.length > 0 &&
            !operationOptions.map((o) => o.value).includes(filter.operation)
        )
            setFilter({ operation: operationOptions[0].value });
    }, [filter.operation, filter.type]);

    return (
        <>
            {!isPerimeterFilter && (
                <Selector
                    className="e2e-filter-operation no-flex-shrink filter-operation"
                    options={operationOptions}
                    value={filter.operation}
                    disabled={!!isDisabled}
                    onChange={(operation: FilterOperationsT) =>
                        setFilter({ operation })
                    }
                    fullWidth={false}
                    preventSorting
                />
            )}

            <ValueSelector
                filter={filter}
                setFilter={setFilter}
                isPerimeterFilter={isPerimeterFilter}
                shouldDebounce={shouldDebounce}
                inputProps={inputProps}
            />
        </>
    );
};
export default SelectorManager;
